module.exports = __webpack_public_path__ + "static/media/copy-black.49e1a6eb.svg";